import { render } from "./modal-dex-assessment.vue?vue&type=template&id=10026c99&scoped=true&ts=true"
import script from "./modal-dex-assessment.vue?vue&type=script&lang=ts"
export * from "./modal-dex-assessment.vue?vue&type=script&lang=ts"

import "./modal-dex-assessment.vue?vue&type=style&index=0&id=10026c99&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10026c99"]])

export default __exports__